// Iter 138 — themed avatar galleries anyone can pick from (Profile → avatar,
// and the In/Out card editor). Original generated artwork, no licensed
// characters. The 1970s set doubles as the deterministic Who's-In fallback.
import { MYSTERY_AVATARS } from "@/lib/mysteryAvatars";

const BASE = "https://static.prod-images.emergentagent.com/jobs/cac67236-8acf-4a22-94ee-7f35274d9105/images";

export const AVATAR_SETS = [
  { key: "mystery", label: "Haunted 70s cartoons", images: MYSTERY_AVATARS },
  {
    key: "princess",
    label: "Storybook princesses",
    images: [
      `${BASE}/723406f4079733b84eef8434d0571e7fb82a3d02a405b72debeda46e9b112ea5.jpeg`,
      `${BASE}/1f7afff2cb1aa1e5e225425e8466b1eaa7a750e88593cfd650b3e01f1fe4c3d6.jpeg`,
      `${BASE}/6bbb074bd39e612a8dab81221aef153842cb4747ef9a0a5aca1d439a57676289.jpeg`,
      `${BASE}/38128f9dc518c1a720aa189885b2f23eadf593c86da06a91f744735b6926d3da.jpeg`,
      `${BASE}/6c2b1492e4ff62e7b0b192c6becd5251bab2df81fd8cf8cadb55439bfaf36dd3.jpeg`,
    ],
  },
  {
    key: "anime",
    label: "Anime icons",
    images: [
      `${BASE}/ede54d6f396c4f3cba8728ec077e022b3853350a5b3a553ebef2c79a576597f0.jpeg`,
      `${BASE}/c9ea1997d8d8d101ecf2e91e1a72ecbf0be568afa643f888ffd6cd7e524ceb46.jpeg`,
      `${BASE}/fa7ae3d3d79ba410885557b6adb85b37aec048070dfe5c5f336dfaf058e995bc.jpeg`,
      `${BASE}/168915f5bf8d155fad1af0d130204067d8cc5c227ee70403ebf95dec7eb33864.jpeg`,
      `${BASE}/c904944342ed75f9f637a5a9744d4367d89ae2471c1919d825dab26410a6cc77.jpeg`,
      `${BASE}/eaa52101e58f12c220fb51fbaf07dd0aab04814272786ddfb15ac061159c2bef.jpeg`,
    ],
  },
  {
    key: "robot",
    label: "Cartoon robots",
    images: [
      `${BASE}/42b9e74ed698f06caab512175457290dc50d023a1166dab6b64510157b7b7ca3.jpeg`,
      `${BASE}/d8d68ec7c14aaf1f190a832a4753fda4031e4201a9abed98f1fd51622c3e2424.jpeg`,
      `${BASE}/ab73d9c01a670966de612de77f2537b01051e621b2b51e22c9309ec76a539fb7.jpeg`,
      `${BASE}/c13ed13a686515728d815a298fc8b2a9118d58ea19a5a838ba2fccfb3a095e3e.jpeg`,
      `${BASE}/7a0639fd3e00bb73953e24199d3e2c8933d5bc260e0c07dfefd1e20c208f31d9.jpeg`,
      `${BASE}/f6714f724414c50ed0a63486530d4842491827877071a111f556629515d0436a.jpeg`,
    ],
  },
];

export const ALL_SET_IMAGES = AVATAR_SETS.flatMap((s) => s.images);

export const setKeyForUrl = (url) =>
  AVATAR_SETS.find((s) => s.images.includes(url))?.key || null;
